import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import "../assets/styles/component.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function ServiceModal(props){

  return (
      <Dialog className="relative z-20" open={props.showModal} onClose={props.setShowModal}>
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-800 bg-opacity-75
        transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300
        data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            style={{zIndex: 10}}
        />

        <div className="fixed inset-0 z-20 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white text-left
            shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0
            data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in
            sm:my-8 sm:w-full sm:max-w-5xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-2 pb-4 pt-5 sm:pb-4 product-modal">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" style={{width: "100%"}}>
                    <DialogTitle as="h3"
                                 className="font-semibold leading-6 text-gray-900 flex items-center justify-between"
                                 style={{fontSize: "1.55rem", textAlign: 'left'}}>
                      <div className='title-component'>
                        {props.icon !== undefined ?
                            <>
                              <div className='product-icon text-advise-color'>
                                <FontAwesomeIcon icon={props.icon} style={{height: "2rem", width: "2rem"}}/>
                              </div>
                              <div className='title-modal text-advise-color'>
                                {props.title}
                              </div>
                            </>
                            :<div className='text-advise-color'>{props.title}</div>}
                      </div>
                      <div className='close-modal-btn'>
                        <button type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200
                      hover:text-red-900 rounded-lg text-sm w-8 h-8 ms-auto
                      inline-flex justify-center items-center dark:hover:bg-red-600
                      dark:hover:text-white transition duration-300 ease-in-out"
                                onClick={() => props.setShowModal(false)}>
                          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                          </svg>
                        </button>
                      </div>
                    </DialogTitle>
                    <div className="mt-2 flex flex-col sm:flex-row">
                      {props.image ? 
                      <>
                        <div className="text-section sm:w-1/2">
                          <p className="text-xl text-gray-500"
                              style={{marginTop: "1.5vh", textAlign: "justify", width: "95%"}}>
                            {props.description}
                          </p>
                        </div>
                        <div className="image-section sm:w-1/2 flex justify-center items-center">
                          {props.image && <img alt={"Servicio Imagen"} src={props.image}  className="rounded-lg" style={{maxWidth: '100%', maxHeight: '100%'}} />}
                        </div>
                      </>         
                      :
                      <div className="text-section">
                          <p className="text-xl text-gray-500"
                              style={{marginTop: "1.5vh", textAlign: "justify"}}>
                            {props.description}
                          </p>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-advise-color
                px-8 py-2 text-md font-semibold text-white shadow-sm hover:bg-blue-400
                sm:ml-3 sm:w-auto service-modal-btn"
                    onClick={() => props.setShowModal(false)}
                >
                  OK
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>)
}
